import { cn } from '@/lib/utils';

export const ChatDayDivider = ({ label, className }) => (
  <div
    role="separator"
    aria-label={label}
    className={cn(
      'flex flex-col items-stretch w-full select-none my-4 px-2',
      className
    )}
  >
    <span className="text-center text-[0.78rem] font-semibold uppercase tracking-wider text-[#8f98ab] mb-1">
      {label}
    </span>
    <span aria-hidden="true" className="h-px w-full bg-[#e2e6ed]" />
  </div>
);

ChatDayDivider.displayName = 'ChatDayDivider';

export default ChatDayDivider;
